import React, { createContext, useContext, ReactNode, useEffect } from 'react';
import { BrandConfig } from '../../types/config.types';
import { detectBrandId, getBrandConfig } from '../brands';

interface BrandContextType {
    brand: BrandConfig;
    brandId: string;
}

interface BrandProviderProps {
    children: ReactNode;
}

const BrandContext = createContext<BrandContextType | undefined>(undefined);

export const BrandProvider = (props: BrandProviderProps): React.ReactElement => {
    const { children } = props;
    const brandId = detectBrandId();
    const brand = getBrandConfig(brandId);
    console.log(brand);
    console.log(brandId);
    // Применяем цветовую схему бренда через CSS-переменные
    useEffect(() => {
        if (typeof document === 'undefined') {
            return;
        }

        const root = document.documentElement;
        const theme = brand.theme || {};

        const setVar = (name: string, value: string | undefined) => {
            if (!value) return;
            root.style.setProperty(name, value);
        };

        // Базовые брендовые переменные
        setVar('--brand-primary', theme.primary);
        setVar('--brand-secondary', theme.secondary);
        setVar('--brand-accent', theme.accent);
        setVar('--brand-background', theme.background);
        setVar('--brand-text', theme.text);
        setVar('--brand-message-bg', theme.messageBackground);

        // Пользовательские CSS-переменные из конфига
        if (theme.cssVariables) {
            Object.entries(theme.cssVariables).forEach(([name, value]) => {
                if (!value) return;
                root.style.setProperty(name, value);
            });
        }
    }, [brand]);

    return (
        <BrandContext.Provider value={{ brand, brandId }}>
            {children}
        </BrandContext.Provider>
    );
};

export const useBrand = (): BrandContextType => {
    const context = useContext(BrandContext);
    if (!context) {
        throw new Error('useBrand must be used within BrandProvider');
    }
    return context;
};